/**
 * Basiq Service Layer
 * Connects directly to your local Spring Boot API gateway.
 */

import { baseUrl_SPB } from "../../../../../BaseUrl";

// If your backend runs on a different port or base path (e.g., http://localhost:8080/api), 
// set it here. Leave empty if your React app is proxied or shares the same domain.
const API_BASE_URL = '';

/**
 * Communicates with your Spring Boot controller:

 * * @param {string} authToken - Your internal JWT application token for security (if applicable)
 * @param {string} basiqUserId - The Basiq user identifier requested by the controller
 * @returns {Promise<Array>} A promise that resolves to the array of bank transactions
 */
export const saveBankTransactionsLocal = async (bankTransaction,token) => {
  try {
    // Construct the URL matching your @RequestParam String basiqUserId
    const url = `${baseUrl_SPB}/api/v1/banktransactionslocal/save`;


    const response = await fetch(`${url}`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bankTransaction),
    });

    if (!response.ok) {
     const  lastError = new Error(`Upload failed at ${url} with status: ${response.status}`);
    
    }

    return response.json();
  } catch (error) {
    const lastError = error;
  }
};